const Confirmar = () => {
   return (
       <>
        <p>Sua senha foi alterada com sucesso!</p>           
        <p>Você já pode realizar o acesso com sua nova senha.</p>           
       </>
   )
}

export default Confirmar;